import React from 'react';
import { tokens } from '../design-system/tokens';

/** Minimal Suspense/auth fallback — no brand lockup (that flashed as a second
 *  "BuzzBit X" on every refresh). Screen-reader text stays for tests/a11y. */
export const PageLoader: React.FC = () => {
  const loaderContainerStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    minHeight: '100vh',
    backgroundColor: '#FFFFFF',
  };

  const spinnerStyles: React.CSSProperties = {
    width: '32px',
    height: '32px',
    border: `2px solid ${tokens.colors.gray[200]}`,
    borderTop: `2px solid ${tokens.colors.accent[600]}`,
    borderRadius: tokens.borderRadius.full,
    animation: 'spin 1s linear infinite',
  };

  return (
    <>
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
      <div style={loaderContainerStyles} role="status" aria-label="Loading">
        <div style={spinnerStyles} aria-hidden="true" />
        <span className="sr-only">Loading...</span>
      </div>
    </>
  );
};
